import React, { useState, useEffect } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { Fieldset, Legend } from "../../components/catalyst/fieldset";
import { AlertMessage } from "../../components/MessageAlert";
import { toast } from "react-toastify";

const jours = {
  lun: "Lundi",
  mar: "Mardi",
  mer: "Mercredi",
  jeu: "Jeudi",
  ven: "Vendredi",
  sam: "Samedi",
};

const PanelPlagesDisponibilites = () => {
  const context = useNotaire();
  const [plages, setPlages] = useState({});
  const [checked, setChecked] = useState({});
  const [recordId, setRecordId] = useState(null);
  const [emailNotaire, setEmailNotaire] = useState("");

  const BASE_ID = "appD48APNaGA4GN0B";

  useEffect(() => {
    if (!context.user?.email) return;

    const emailForPlages = (context.user.role === 'secretaire' && context.user.email_notaire)
      ? context.user.email_notaire
      : context.user.email;

    const fetchPlages = async () => {
      try {
        const res = await fetch(
          `https://api.airtable.com/v0/${BASE_ID}/plages_disponibilites?filterByFormula=SEARCH("${emailForPlages}",{email_notaire})`,
          {
            headers: {
              Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();

        if (!data.records || data.records.length === 0) {
          console.warn("Aucune plage de disponibilité trouvée");
          return;
        }

        const record = data.records[0];
        const fields = record.fields || {};

        setRecordId(record.id);
        setPlages(fields);

        const emailVal = Array.isArray(fields.email_notaire)
          ? fields.email_notaire[0] || ""
          : fields.email_notaire || context.user?.email || "";
        setEmailNotaire(emailVal);

        const checkedMap = {};
        Object.keys(jours).forEach((jour) => {
          const val = fields[jour];
          checkedMap[jour] = val && val.toLowerCase() !== "fermé";
        });
        setChecked(checkedMap);
      } catch (err) {
        console.error("Erreur chargement plages disponibilités:", err);
        toast.error("Erreur lors du chargement des plages");
      }
    };

    fetchPlages();
  }, [context.user?.email]);

  const handleCheck = (jour) => {
    setChecked((prev) => ({ ...prev, [jour]: !prev[jour] }));
  };

  const handlePlageChange = (jour, value) => {
    setPlages((prev) => ({ ...prev, [jour]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recordId) {
      toast.error("Enregistrement introuvable. Contactez le support.");
      return;
    }

    const payload = {};
    Object.keys(jours).forEach((jour) => {
      payload[jour] = checked[jour] ? plages[jour] || "" : "fermé";
    });

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/${BASE_ID}/plages_disponibilites/${recordId}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fields: payload }),
        }
      );

      if (res.ok) {
        toast.success("Plages de disponibilités mises à jour !");
      } else {
        const err = await res.text();
        console.error("Airtable error:", err);
        toast.error("Erreur de mise à jour");
      }
    } catch (err) {
      console.error("Erreur réseau:", err);
      toast.error("Erreur réseau");
    }
  };

  return (
    <>
    <AlertMessage
        type="info"
        message="C'est ici que vous ouvrez ou bloquez des plages pour la prise de rendez-vous sur Clotere. Cochez les jours où vous acceptez des rendez-vous et indiquez les horaires. "
      />
    <div className="bg-white p-6 rounded shadow mt-8">
      



      <form onSubmit={handleSubmit}>
        <Fieldset>
          <Legend>Plages de disponibilités</Legend>
          <ul className="divide-y divide-gray-200">
            {Object.entries(jours).map(([jour, label]) => (
              <li className="py-4" key={jour}>
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={checked[jour] || false}
                    onChange={() => handleCheck(jour)}
                  />
                  <span>{label}</span>
                </label>

                {checked[jour] && (
                  <input
                    type="text"
                    value={plages[jour] || ""}
                    onChange={(e) => handlePlageChange(jour, e.target.value)}
                    placeholder="Ex: 09:00 - 18:00"
                    className="mt-2 w-full border p-2 rounded"
                  />
                )}
              </li>
            ))}
          </ul>
        </Fieldset>

        <button type="submit" className="btn-primary mt-4">
          Enregistrer les plages
        </button>
      </form>
    </div>
    </>
  );
};

export default PanelPlagesDisponibilites;
